import React, { FC } from 'react';

type PopupProps = {
   handlePopup:() =>void,
   lang:string
    }
export const PopupIOs: FC<PopupProps> = ({ handlePopup, lang }) => {
  // eslint-disable-next-line react/jsx-props-no-spreading

  const getLanguage = () => {
    switch (lang) {
      case 'en':

        return (
          <p>
            To get the best AR user experience, please use the built-in Safari for iOS browser.
            <span onClick={handlePopup} role="button" tabIndex={0}>OK!</span>
          </p>
        );

      case 'pl':

        return (
          <p>
            Aby optymalnie korzystać z aplikacji, należy używać przeglądarki Safari.
            <span onClick={handlePopup} role="button" tabIndex={0}>OK!</span>
          </p>
        );
      default:
        return (
          <p>
            Bitte nutzen Sie Safari, um die Anwendung optimal zu erleben.
            <span onClick={handlePopup} role="button" tabIndex={0}>OK!</span>
          </p>
        );
    }
  };
  return (
    <div className="pop-up">
      {getLanguage()}
    </div>
  );
};
